import { Reveal } from "./Reveal";
import { media } from "@/data/site";

const items = ["Etichetta.", "Cartellino.", "Packaging.", "Personalizzazione finale."];

export const Branding = () => {
  return (
    <section id="branding" className="bg-ivory py-24 sm:py-36" data-testid="branding-on-demand">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-sans-ui text-[11px] tracking-mega text-ink/40 mb-6">CAPITOLO 05 — BRANDING ON DEMAND</p>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <Reveal delay={0.05}>
              <h2 className="font-display font-light text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                Il tuo branding segue le tue vendite. Non le precede.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 font-sans-ui text-sm sm:text-base text-ink/70 leading-relaxed max-w-lg">
                Non hai bisogno di personalizzare centinaia di unità prima di sapere se verranno vendute.
                Quando ricevi un ordine, prendiamo l'unità acquistata e la prepariamo secondo la
                configurazione del tuo brand.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 space-y-1">
                {items.map((t) => (
                  <p key={t} className="font-display text-3xl sm:text-4xl text-ink border-b hairline pb-3">{t}</p>
                ))}
                <p className="font-sans-ui text-xs tracking-mega text-ink/45 pt-5">SOLO QUANDO SERVONO.</p>
              </div>
            </Reveal>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <Reveal delay={0.1} className="col-span-2">
              <div className="overflow-hidden bg-linen aspect-[16/10]">
                <img src={media.brandingLabel} alt="Etichetta cucita YOUR BRAND" loading="lazy" className="w-full h-full object-cover" />
              </div>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="overflow-hidden bg-linen aspect-square">
                <img src={media.brandingHangtag} alt="Cartellino YOUR BRAND" loading="lazy" className="w-full h-full object-cover" />
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="overflow-hidden bg-linen aspect-square">
                <img src={media.brandingPackaging} alt="Packaging coordinato YOUR BRAND" loading="lazy" className="w-full h-full object-cover" />
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.05}>
          <p className="mt-20 sm:mt-28 font-display italic font-light text-4xl sm:text-6xl lg:text-7xl text-ink leading-tight text-center">
            La tua identità, applicata ordine per ordine.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
